import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import hoardingHtml from '../components/Darshan_Hoarding_Display_PureHTML.html?raw';

// 16 Oct 2026 (operators): shown on a 100-inch screen - the hoarding is laid out for 1920 x 1080 and is scaled as a
// whole to fill whatever screen it is on (4K, 1080p, a laptop), keeping its proportions and sharpness
const DESIGN_W = 1920;
const DESIGN_H = 1080;

export const DirectionPage: React.FC = () => {
  const [fit, setFit] = useState(() => ({ scale: 1, left: 0, top: 0 }));
  useEffect(() => {
    const update = () => {
      const scale = Math.min(window.innerWidth / DESIGN_W, window.innerHeight / DESIGN_H);
      setFit({ scale, left: (window.innerWidth - DESIGN_W * scale) / 2, top: (window.innerHeight - DESIGN_H * scale) / 2 });
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'Sri Kanaka Durga Devi Temple — Darshan Hoarding Display';
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        backgroundColor: '#051b3b',
        zIndex: 99999,
      }}
    >
      <iframe
        title="Darshan Hoarding Display"
        srcDoc={hoardingHtml}
        style={{
          position: 'absolute',
          left: fit.left,
          top: fit.top,
          width: DESIGN_W,
          height: DESIGN_H,
          transform: `scale(${fit.scale})`,
          transformOrigin: 'top left',
          border: 'none',
          display: 'block',
          margin: 0,
          padding: 0,
          overflow: 'hidden',
        }}
        allow="fullscreen"
      />

      {/* Discreet return button positioned at bottom-left */}
      <Link
        to="/overview"
        title="Return to Crowd Management Portal"
        style={{
          position: 'fixed',
          bottom: '34px',
          left: '16px',
          background: 'rgba(4, 23, 49, 0.9)',
          border: '1px solid rgba(223, 176, 82, 0.65)',
          color: '#f7d678',
          padding: '6px 14px',
          borderRadius: '20px',
          fontSize: '0.75rem',
          fontWeight: 700,
          textDecoration: 'none',
          zIndex: 100000,
          backdropFilter: 'blur(8px)',
          opacity: 0.35,
          transition: 'opacity 0.25s ease, transform 0.2s',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '1';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '0.35';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        ← Portal
      </Link>
    </div>
  );
};

export default DirectionPage;
